import { Loader2 } from './icons';
export function LoadingFallback() {
  return (<div style={{ flex: 1, display: "flex", alignItems: "center", justifyContent: "center", padding: "var(--space-12)" }}><Loader2 size={32} color="var(--color-primary)" style={{ animation: "spin 1s linear infinite" }} aria-label="Loading" /></div>);
}